module.exports = __webpack_public_path__ + "img/marker_red.e0b462f.svg";